import React from 'react';
import { HeaderDialog } from 'styles/Styles.styled';
import DialogClearStyles, {
  DialogClearStylesButtonsFooter,
  DialogContent,
  DialogFooter,
} from 'components/accounts/DialogClearStyles';
import { PrimaryButton, SecondaryButton } from 'components/v2/buttons';
import { RoleModel } from 'services/EpdClient';
import CheckboxOption from '../checkbox-option/CheckboxOption';
import { AlertIcon } from 'components/v2/icons';
import { RoleName } from 'constants/constants';
import Tooltip from 'components/controls/Tooltip';

interface Props {
  visible: boolean;
  isLeavingOrganisation: boolean;
  context: {
    companyId: string;
    companyName: string;
    roles: RoleModel[];
    isUserVerifierInHomeCompany: boolean;
  };
  selectedRoleIds: string[] | null;
  onHide(): void;
  onToggleRole: (roleId: string) => void;
  onLeave(): void;
}

const RemoveRolesDialog: React.FC<Props> = ({
  visible,
  isLeavingOrganisation,
  context,
  selectedRoleIds,
  onHide,
  onToggleRole,
  onLeave,
}) => {
  return (
    <DialogClearStyles
      visible={visible}
      onHide={onHide}
      header={
        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', marginTop: 40 }}>
          <AlertIcon />
          <HeaderDialog style={{ maxWidth: 405, marginBottom: 14, fontSize: 18 }}>
            Do you want to leave {context.companyName}?
          </HeaderDialog>
        </div>
      }
      closable={false}
      draggable={false}
    >
      <DialogContent style={{ maxWidth: 405, paddingLeft: 0, paddingRight: 0, marginLeft: 60, marginRight: 60 }}>
        {context.roles.length > 1 ? (
          <>
            <div style={{ marginBottom: 30, textAlign: 'center', fontSize: 14, color: '#151515B2' }}>
              You have multiple roles in this organisation.
              <br />
              Please choose the role you want to remove.
            </div>
            <div style={{ display: 'grid', gap: 8 }}>
              {context.roles.map((role) => {
                const isRoleDisabled = role.name === RoleName.EPD_VERIFIER && context.isUserVerifierInHomeCompany;
                return (
                  <div key={role.id}>
                    <CheckboxOption
                      checked={!!selectedRoleIds?.includes(role.id!)}
                      label={role.name!}
                      onValueChanged={() => onToggleRole(role.id!)}
                      disabled={isRoleDisabled}
                    />
                    {isRoleDisabled && (
                      <Tooltip position={'mouse'}>
                        EPD Verifiers cannot leave their organisation. Please contact support for changes.
                      </Tooltip>
                    )}
                  </div>
                );
              })}
            </div>
          </>
        ) : (
          <div style={{ marginBottom: 30, textAlign: 'center', fontSize: 14, color: '#151515B2' }}>
            Once you leave this organisation, you will no longer have access to it or its EPDs. To regain access in the
            future, you must be invited or request access to the organisation.
          </div>
        )}
        <DialogFooter>
          <DialogClearStylesButtonsFooter>
            <SecondaryButton type="button" label="Cancel" onClick={onHide} />
            <PrimaryButton
              type="button"
              label={isLeavingOrganisation ? 'Leaving...' : 'Confirm'}
              onClick={onLeave}
              disabled={
                (context.roles.length > 1 && (!selectedRoleIds || selectedRoleIds.length === 0)) || isLeavingOrganisation
              }
            />
          </DialogClearStylesButtonsFooter>
        </DialogFooter>
      </DialogContent>
    </DialogClearStyles>
  );
};

export default RemoveRolesDialog;
